import { getSelectedSizes as getSelectedSizesFromDraft } from '@/model/draft/getSelectedSizes';
import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

export const getSelectedSizes = (state: StoreState) => getSelectedSizesFromDraft(getDraft(state));
